import type { MockRequest, MockResponse } from "@/mocks/router";
import { store } from "@/mocks/store";
import { ok } from "./_utils";

export function handleSdk(req: MockRequest): MockResponse | null {
  const method = req.method.toUpperCase();
  const path = req.path.replace(/\/+$/, "") || "/";

  if (method === "GET" && path === "/api/sdk/releases") return ok({ data: store.SDK_VERSIONS });
  if (method === "GET" && path === "/api/sdk/monitor/summary") return ok({ data: store.SDK_MONITOR.summary });
  if (method === "GET" && path === "/api/sdk/monitor/apis") return ok({ data: store.SDK_MONITOR.api_calls });
  if (method === "GET" && path === "/api/sdk/monitor/errors") return ok({ data: store.SDK_MONITOR.errors });
  if (method === "GET" && path === "/api/sdk/monitor") return ok({ data: store.SDK_MONITOR });

  return null;
}
